// @ts-nocheck
import { field, GfxPrimitiveElementModel } from '@blocksuite/block-std/gfx';
import type { SerializedXYWH } from '@blocksuite/global/utils';

export type HighlightTheme = 'brand' | 'success' | 'warning' | 'error';

export class MindmapHighlightElementModel extends GfxPrimitiveElementModel {
    @field()
    accessor xywh: SerializedXYWH = '[0,0,0,0]';

    @field()
    accessor nodeId: string = '';

    @field()
    accessor startMs: number = 0;

    @field()
    accessor durationMs: number = 800;

    @field()
    accessor theme: HighlightTheme = 'brand';

    @field()
    accessor colorLight: string | null = null;

    @field()
    accessor colorMain: string | null = null;

    @field()
    accessor colorDark: string | null = null;

    override get rotate(): number {
        return 0;
    }

    override set rotate(_: number) { }

    get type(): string {
        return 'mindmap-highlight';
    }
}

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace BlockSuite {
        interface SurfaceElementModelMap {
            'mindmap-highlight': MindmapHighlightElementModel;
        }
    }
}


